import { toast } from 'react-toastify';

export const STATE_OPTIONS = [
  { label: 'Alabama', value: 'AL' },
  { label: 'Alaska', value: 'AK' },
  { label: 'Arizona', value: 'AZ' },
  { label: 'Arkansas', value: 'AR' },
  { label: 'California', value: 'CA' },
  { label: 'Colorado', value: 'CO' },
  { label: 'Connecticut', value: 'CT' },
  { label: 'Delaware', value: 'DE' },
  { label: 'District of Columbia', value: 'DC' },
  { label: 'Florida', value: 'FL' },
  { label: 'Georgia', value: 'GA' },
  { label: 'Hawaii', value: 'HI' },
  { label: 'Idaho', value: 'ID' },
  { label: 'Illinois', value: 'IL' },
  { label: 'Indiana', value: 'IN' },
  { label: 'Iowa', value: 'IA' },
  { label: 'Kansas', value: 'KS' },
  { label: 'Kentucky', value: 'KY' },
  { label: 'Louisiana', value: 'LA' },
  { label: 'Maine', value: 'ME' },
  { label: 'Maryland', value: 'MD' },
  { label: 'Massachusetts', value: 'MA' },
  { label: 'Michigan', value: 'MI' },
  { label: 'Minnesota', value: 'MN' },
  { label: 'Mississippi', value: 'MS' },
  { label: 'Missouri', value: 'MO' },
  { label: 'Montana', value: 'MT' },
  { label: 'Nebraska', value: 'NE' },
  { label: 'Nevada', value: 'NV' },
  { label: 'New Hampshire', value: 'NH' },
  { label: 'New Jersey', value: 'NJ' },
  { label: 'New Mexico', value: 'NM' },
  { label: 'New York', value: 'NY' },
  { label: 'North Carolina', value: 'NC' },
  { label: 'North Dakota', value: 'ND' },
  { label: 'Ohio', value: 'OH' },
  { label: 'Oklahoma', value: 'OK' },
  { label: 'Oregon', value: 'OR' },
  { label: 'Pennsylvania', value: 'PA' },
  { label: 'Puerto Rico', value: 'PR' },
  { label: 'Rhode Island', value: 'RI' },
  { label: 'South Carolina', value: 'SC' },
  { label: 'South Dakota', value: 'SD' },
  { label: 'Tennessee', value: 'TN' },
  { label: 'Texas', value: 'TX' },
  { label: 'Utah', value: 'UT' },
  { label: 'Vermont', value: 'VT' },
  { label: 'Virginia', value: 'VA' },
  { label: 'Washington', value: 'WA' },
  { label: 'West Virginia', value: 'WV' },
  { label: 'Wisconsin', value: 'WI' },
  { label: 'Wyoming', value: 'WY' },
];

export const PROVINCE_OPTIONS = [
  { label: 'Alberta', value: 'AB' },
  { label: 'British Columbia', value: 'BC' },
  { label: 'Manitoba', value: 'MB' },
  { label: 'New Brunswick', value: 'NB' },
  { label: 'Newfoundland and Labrador', value: 'NL' },
  { label: 'Nova Scotia', value: 'NS' },
  { label: 'Ontario', value: 'ON' },
  { label: 'Prince Edward Island', value: 'PE' },
  { label: 'Quebec', value: 'QC' },
  { label: 'Saskatchewan', value: 'SK' },
  { label: 'Northwest Territories', value: 'NT' },
  { label: 'Yukon', value: 'YT' },
];

export const COUNTRY_LIST = ['United States', 'Canada'];

export const userRoles = {
  superAdmin: 'superAdmin',
  admin: 'admin',
  user: 'user',
  companyGroupAdmin: 'companyGroupAdmin',
  agent: 'agent',
  epikBox: 'epikBox',
  companyGroupManager: 'companyGroupManager',
  enterpriseAdmin: 'enterpriseAdmin',
  licenseManager: 'licenseManager',
  supportEngineer: 'supportEngineer',
  restbin: 'restbin',
  quoteToolAdmin: 'quoteToolAdmin',
  authenticateAdmin: role => {
    return (
      role === 'superAdmin' ||
      role === 'companyGroupAdmin' ||
      role === 'supportEngineer' ||
      role === 'enterpriseAdmin'
    );
  },
};

export const bandModelWindowsOption = {
  faInput: 'faInput',
  faAuth: 'faAuth',
  webSSH: 'webSSH',
  ttyShell: 'ttyShell',
};

export const numberCarrierOptions = [
  { value: 'inteliquent', label: 'Inteliquent' },
  { value: 'tdm', label: 'TDM' },
  { value: 'voicetel', label: 'Voicetel' },
  { value: 'verizontdm', label: 'Verizon TDM' },
  { value: 'verizonsip', label: 'Verizon SIP' },
  { value: 'telnyx', label: 'Telnyx' },
  { value: 'iqtollfree', label: 'IQ Toll-Free' },
  { value: 'nonepikline', label: 'Non EPIK Line' },
  { value: 'skyt', label: 'Skyetel' },
];

export const hiddenNumberCarrierOptions = (value, numberCarrierChangeAccess) => {
  return value === 'voicetel' || (!(numberCarrierChangeAccess === 'write' || numberCarrierChangeAccess === 'both') && value === 'tdm');
};
export function handleError(error, unhandledMessage) {
  let message;
  if (typeof error === 'string') {
    message = error;
  }
  if (typeof error?.response === 'string') {
    message = error.response;
  }
  if (typeof error?.response?.data === 'string') {
    message = error.response.data;
  }
  if (message) {
    toast.error(error.response.data);
  } else {
    console.log(error);
    if (unhandledMessage) {
      toast.info('Unable to fetch routes');
    }
  }
}

export const securityPinActivities = {
  resetBoxToDefault: 'Reset to Default',
  companyDeletionCode: 'Deleting Company Groups',
  epikUpdateBtnDisable: 'Disable EPIK Update on Admin Tools',
  enableDisablePortCode: 'Port Enable/Disable',
  hiddenDelete: 'Access Secret Delete',
  datacenterCode: 'Data Center Switch',
  faxCode: 'Fax Toggle Switch',
  trunkCode: 'Change Trunk',
  rceSecurity: 'REC',
  diagnostics: 'Access Diagnostic Tab',
  portingCode: 'Porting in Carrier Hub',
  numberCode: 'Delete ATA from EPI Tab',
  superCode: 'Set SuperAdmin',
  engineeringLock: 'Engineering Lock',
  alarmProtocol: 'APR Enablement',
  cancelIntegrate: 'Integration',
  demoCode: 'Remove Read Only Access',
  enhancedRouting: 'Enhanced Routing',
  secondaryNotify: 'Secondary Notification',
  dcAutoUpdate: 'DC Auto Select',
  internationalDialing: 'International Dialing',
  monitorCode: 'Enable Monitoring',
  bandManagement: 'Out of Band Management',
  unassign: 'Unassign Number',
  code2FA: 'Disable 2FA',
  outboundSecuriety: 'outboundSecuriety',
  deleteCompany: 'deleteCompany',
  deleteEnterprise: 'deleteEnterprise',
  updateUser: 'updateUser',
  deleteUser: 'deleteUser',
  secondary: 'secondary tunnel',
  serialNumberUpdate: 'Serial Number Update',
  EPI: 'Delete EPI',
  integratedPort: 'integratedPort',
  omitLeading9: 'omitLeading9',
  ttyCode: 'ttyCode',
  failOverOptions:"Failover Options"
};

const {
  REACT_APP_RCE,
  REACT_APP_GOD_MODE_CODE,
  REACT_APP_DIAGNOSTICS_CODE,
  REACT_APP_GAMMA,
  REACT_APP_PORTING_CODE,
  REACT_APP_NUMBER_DELETE_CODE,
  REACT_APP_TRUNK_MODE_CODE,
  REACT_APP_SUPER_MODE_CODE,
  REACT_APP_FAX_CODE,
  REACT_APP_ENGINEERING_LOCK_CODE,
  REACT_APP_DATACENTER_CODE,
  REACT_APP_ALARM_PROTOCOL_CODE,
  REACT_APP_ENABLE_DISABLE_PORT_CODE,
  REACT_APP_HIDDEN_DELETE_CODE,
  REACT_APP_COMPANY_DELETION_CODE,
  REACT_APP_RESET_BOX_TO_DEFAULT,
  REACT_APP_EPIK_UPDATE_BTN_DISABLE,
  REACT_APP_CANCEL_INTEGRATION_CODE,
  REACT_APP_ENHACED_ROUTING_CODE,
  REACT_APP_DEMO_CODE,
  REACT_APP_SECONDARY_NOTIFY_CODE,
  REACT_APP_DC_AUTO_UPDATE,
  REACT_APP_MONITOR_CODE,
  REACT_APP_BAND_MANAGEMENT,
  REACT_APP_UNASSIGN_NUMBER,
  REACT_APP_2FA_CODE,
  REACT_APP_INTEGRATED_PORT_CODE,
  REACT_APP_ADMIN_DASHBOARD_CODE,
  REACT_APP_PRI_FAILOVER,
  REACT_APP_OMIT_LEADING9,
  REACT_APP_TTY_CODE,
  REACT_APP_POWER_SAVE_CODE,
  REACT_APP_INTERNATIONAL_DIALING,
  REACT_APP_ETH3_DISABLE,
  REACT_APP_CALL_WAITING,
  REACT_APP_ACCESS_CONTROL,
  REACT_APP_CAS_FAILOVER
} = process.env;

export const PIN_CODES_LIST = {
  resetBoxToDefault: REACT_APP_RESET_BOX_TO_DEFAULT,
  rceSecurity: REACT_APP_RCE,
  default: REACT_APP_GOD_MODE_CODE,
  diagnostics: REACT_APP_DIAGNOSTICS_CODE,
  multiCode: REACT_APP_GAMMA,
  portingCode: REACT_APP_PORTING_CODE,
  numberCode: REACT_APP_NUMBER_DELETE_CODE,
  trunkCode: REACT_APP_TRUNK_MODE_CODE,
  superCode: REACT_APP_SUPER_MODE_CODE,
  faxCode: REACT_APP_FAX_CODE,
  engineeringLock: REACT_APP_ENGINEERING_LOCK_CODE,
  datacenterCode: REACT_APP_DATACENTER_CODE,
  alarmProtocol: REACT_APP_ALARM_PROTOCOL_CODE,
  enableDisablePortCode: REACT_APP_ENABLE_DISABLE_PORT_CODE,
  hiddenDelete: REACT_APP_HIDDEN_DELETE_CODE,
  companyDeletionCode: REACT_APP_COMPANY_DELETION_CODE,
  epikUpdateBtnDisable: REACT_APP_EPIK_UPDATE_BTN_DISABLE,
  cancelIntegrate: REACT_APP_CANCEL_INTEGRATION_CODE,
  enhancedRouting: REACT_APP_ENHACED_ROUTING_CODE,
  demoCode: REACT_APP_DEMO_CODE,
  secondaryNotify: REACT_APP_SECONDARY_NOTIFY_CODE,
  dcAutoUpdate: REACT_APP_DC_AUTO_UPDATE,
  internationalDialing: REACT_APP_INTERNATIONAL_DIALING,
  monitorCode: REACT_APP_MONITOR_CODE,
  bandManagement: REACT_APP_BAND_MANAGEMENT,
  unassign: REACT_APP_UNASSIGN_NUMBER,
  code2FA: REACT_APP_2FA_CODE,
  integratedPort: REACT_APP_INTEGRATED_PORT_CODE,
  adminDash: REACT_APP_ADMIN_DASHBOARD_CODE,
  priFailover: REACT_APP_PRI_FAILOVER,
  omitLeading9: REACT_APP_OMIT_LEADING9,
  ttyCode: REACT_APP_TTY_CODE,
  eth3Disable: REACT_APP_ETH3_DISABLE,
  powerSave: REACT_APP_POWER_SAVE_CODE,
  callWaiting: REACT_APP_CALL_WAITING,
  accessControl: REACT_APP_ACCESS_CONTROL,
  casFailover: REACT_APP_CAS_FAILOVER,
};

export const PIN_CODES_NAME = {
  resetBoxToDefault: 'resetBoxToDefault',
  rceSecurity: 'rceSecurity',
  default: 'default',
  diagnostics: 'diagnostics',
  multiCode: 'multiCode',
  portingCode: 'portingCode',
  numberCode: 'numberCode',
  trunkCode: 'trunkCode',
  superCode: 'superCode',
  faxCode: 'faxCode',
  engineeringCode: 'engineeringCode',
  datacenterCode: 'datacenterCode',
  alarmProtocol: 'alarmProtocol',
  enableDisablePortCode: 'enableDisablePortCode',
  hiddenDelete: 'hiddenDelete',
  companyDeletionCode: 'companyDeletionCode',
  epikUpdateBtnDisable: 'epikUpdateBtnDisable',
  cancelIntegrate: 'cancelIntegrate',
  enhancedRouting: 'enhancedRouting',
  demoCode: 'demoCode',
  secondaryNotify: 'secondaryNotify',
  dcAutoUpdate: 'dcAutoUpdate',
  internationalDialing: 'internationalDialing',
  monitorCode: 'monitorCode',
  bandManagement: 'bandManagement',
  unassign: 'unassign',
  code2FA: 'code2FA',
  integratedPort: 'integratedPort',
  adminDash: 'adminDash',
  priFailover: 'priFailover',
  omitLeading9: 'omitLeading9',
  ttyCode: 'ttyCode',
  eth3Disable: 'eth3Disable',
  powerSave: 'powerSave',
  callWaiting: 'callWaiting',
  accessControl: 'accessControl'
};
// Permission constants in reverse
export const PERMISSIONS = {
  numberCarrierChangeAccess: 'Carrier Access',
  portingAccessEnabled: 'Carrier Hub: Porting',
  dataCenterMonitor: 'Data Center Monitor',
  warehouseQcAccess: 'Warehouse QC Wizard',
  eth3Access: 'Eth0/3 Disable',
  pcapModulePermission: 'PCAP Lookup',
  portConfigurationAccess: 'Port Configuration Management',
  engineeringLock: 'Engineering Lock',
  registrationOffSet: 'Registration Offset',
  dataCenter: 'Data Center Registration',
  powerSave: 'Power Save',
  cancelIntegrationAccess: 'Integration',
  realTimeActivityEnabled: 'PCAP Analyzer',
  nocWizardAccess: 'NOC Wizard',
  phoneAccess: 'IP Phone Management',
  internationalDialingAccess: 'International Dialing',
  recDiagnostics: 'REC Menu',
  omitLeading: 'Omit 9',
  outBandManagement: 'Out of Band Management',
  callWaiting: 'Call Waiting',
  deleteEpi: 'Delete EPI',
  modifyEPIS: 'Modify EPI',
  numberBulkActionsAccess: 'Bulk Number Action',
  epiUtilitiesPermission: 'EPI Utilities',
  callerIdMaskingAccess: 'Caller ID Masking',
  enableMonitoring: 'Device Monitoring',
  eventsAccess: 'Events',
  epikUpdates: 'Epik Updates',
  adminDashboardAccess: 'Admin Dashboard Access',
  enhancedAnalyzer: 'Enhanced Analyzer',
  ttyOptionsAccess: 'TTY Access Management',
  enableAlarmProtocol: 'Enable Alarm Relay Protocol',
  epiFirmwareUpdate: 'EPI firmware update',
  docToolAccess: 'Documentation Tool',
  // epikEngineering: 'EPIK Engineering Toggle',
  pmToolsAccess: 'PM Tools',
  tcToolsAccess: 'TC Tools',
  nocLogsAccess: 'Noc Logs Access',
  deviceHistoricalData: 'Device Historical Data',
  edgmonpermission: 'Edge Monitor',
  batteryReplacedOn: 'Battery Replaced On',
  orderBtnOobm: 'Order BTN',
  OobmAccess: 'OOBM Assignment',
  bulkUserUpload: 'Bulk Account Add',
  secureInfo: 'Secure Info',
  enableDisablePort: 'Enable Disable Port',
  outboundOverride: 'Outbound Override',
  trunkSelection: 'Trunk Selection',
  deleteCompany: 'Delete Company',
  resetToDefault: 'Reset to Default',
  disableOobmTerminal:"Disable OOBM Portal Terminal Emulator",
  failOverOptions: 'Failover Options',
  deleteCompanyGroup: 'Delete Company Group',
  callFeatures:'Call Features',
  wikiAccess:"Wiki Access",
  outboundLowMTU:"Outbound Low MTU",
  epikPlatform:'EPIK Monitoring Services',

  threeWayCalling:"3 Way Calling",
  callTransfer:"Call Transfer",
  callForwardBusy:"Call Forward Busy",
  callForwardNoAnswer:"Call Forward No-Answer",
  callForwardAlways:"Call Forward Always",
  remoteCallForward:"Remote Call Forwarding",
  callRejection:"Anonymous Call Rejection",
  callBlocking:"Call Blocking",
  doNotDisturb:"Do Not Disturb",
  demoBox:"Enable Demo Box",
  newNumber: 'New Number',
  numberForceUnlink:"Number Force Unlink",
  activeEdgeDevice:"Active Edge Device"
};
export const PERMISSION_GROUPS = {
  callFeatures: ['threeWayCalling', 'callTransfer','callForwardBusy','callForwardNoAnswer','callForwardAlways','remoteCallForward','callRejection','callBlocking','doNotDisturb','callWaiting'],
  // wikiAccess: ['portingAccessEnabled', 'numberCarrierChangeAccess'],
};

// export const PERMISSIONGROUPS ={
//   Engineering : 'Engineering',
//    NOC : 'NOC',
//    Premier : 'Premier',
//    PM : 'PM',
//    SE : 'SE',
//    Warehouse : 'Warehouse',
//    Activations : 'Activations',
//    Sales : 'Sales',
//    Partner : 'Partner',
//    Customer : 'Customer',
// }
export const RESTRICTED_PERMISSION_GROUPS = ['Engineering', 'NOC', 'Premier', 'PM', 'SE', 'Warehouse', 'Activations', 'Sales', 'Partner', 'Customer', 'Auditor','Manufacturer','OOBM Only'];

//EPI
//outboundSecuriety multi
//serialNumberUpdate default
//deleteCompany/ deleteEnterprise, default
//updateUser/deleteUser, (default)
//boxActivation/firmwareUpdate, multi
export const multiCodeFeature = [
  'outboundSecuriety',
  'boxActivation',
  'firmwareUpdate',
  'secondary',
];

export const FIRMWARE_VERSION = 'V1.0.0.061311331';
export  const esceneFromObiValues = {
  '30': "0" ,
  '40': "1" ,
  '50': "2" ,
  '60': "3" ,
  '70': "4" ,
  '80': "5" 
};
